"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandValidationService = void 0;
var BrandValidationService_1 = require("./implementation/BrandValidationService");
exports.brandValidationService = new BrandValidationService_1.BrandValidationService();
//# sourceMappingURL=index.js.map